import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { isValid } from "date-fns";
import en_GBLocale from "date-fns/locale/en-GB";
const parseValue = (value) => {
    if (!value)
        return null;
    const date = new Date(value);
    return isValid(date) ? date : null;
};
const formatDateString = (date, type, status) => {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const overrideSeconds = type !== "date" && status !== undefined;
    const seconds = overrideSeconds
        ? status === "start"
            ? "00"
            : "59"
        : ("0" + date.getSeconds()).slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
export default function InputDatetime({ type, label, required, value, setValue, caption, info, status, disabled, error, errors, isError, setIsError, }) {
    const [dateError, setDateError] = useState(false);
    const [pickerValue, setPickerValue] = useState(() => parseValue(value));
    const lastEmittedRef = useRef(value);
    useEffect(() => {
        if (value !== lastEmittedRef.current) {
            setPickerValue(parseValue(value));
            lastEmittedRef.current = value;
        }
    }, [value]);
    const clearErrorFlag = () => {
        if (isError &&
            errors &&
            error &&
            setIsError &&
            (errors === null || errors === void 0 ? void 0 : errors.hasOwnProperty(error))) {
            setIsError(false);
        }
    };
    const handleChange = (date) => {
        if (date === null) {
            setPickerValue(null);
            lastEmittedRef.current = null;
            setValue(null);
            if (dateError)
                setDateError(false);
            clearErrorFlag();
            return;
        }
        if (!isValid(date)) {
            setDateError(true);
            clearErrorFlag();
            return;
        }
        const formatted = formatDateString(date, type, status);
        if (!isValid(new Date(formatted))) {
            setDateError(true);
            clearErrorFlag();
            return;
        }
        setDateError(false);
        setPickerValue(date);
        lastEmittedRef.current = formatted;
        setValue(formatted);
        clearErrorFlag();
    };
    const renderTextField = (props) => (_jsx(TextField, Object.assign({}, props, { label: label, required: required, fullWidth: true, helperText: isError && errors && error && (errors === null || errors === void 0 ? void 0 : errors.hasOwnProperty(error))
            ? errors[error][0]
            : info
                ? info
                : false, error: isError && errors && error
            ? errors === null || errors === void 0 ? void 0 : errors.hasOwnProperty(error)
            : type === "time"
                ? dateError && value !== "" && value !== null
                : dateError })));
    return (_jsxs(Fragment, { children: [caption && (_jsx(Box, Object.assign({ sx: { paddingBottom: 2 } }, { children: _jsx(Typography, { children: caption }) }))), _jsx(FormControl, Object.assign({ fullWidth: true, error: isError && errors && error ? errors === null || errors === void 0 ? void 0 : errors.hasOwnProperty(error) : false }, { children: _jsx(LocalizationProvider
                // @ts-ignore
                , Object.assign({ 
                    // @ts-ignore
                    dateAdapter: AdapterDateFns, adapterLocale: en_GBLocale }, { children: type === "date_time" ? (_jsx(DateTimePicker, { label: label, disabled: disabled ? disabled : false, renderInput: renderTextField, onChange: handleChange, value: pickerValue })) : type === "date" ? (_jsx(DatePicker, { label: label, disabled: disabled ? disabled : false, renderInput: renderTextField, value: pickerValue, onChange: handleChange })) : (_jsx(TimePicker, { disabled: disabled ? disabled : false, label: label, renderInput: renderTextField, value: pickerValue, onChange: handleChange })) })) }))] }));
}
